import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Button, Checkbox, Form, message, Modal, Spin, Switch } from 'udesk-ui';
import { getCompanysQueryLoginVerification } from 'src/api/companys/queryLoginVerification';
import { postCompanysLoginVerification } from 'src/api/companys/loginVerification';
import { PostCompanysLoginVerificationBody } from 'src/api/types';
import { OpenMap } from './const';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {}

interface FormValues
    extends Omit<
        PostCompanysLoginVerificationBody,
        'twoStepVerification' | 'loginVerificationConfig'
    > {
    twoStepVerification?: boolean;
    loginVerificationConfig?: boolean;
}

const Template: FC<TemplateProps> = memo((props) => {
    const [form] = Form.useForm<FormValues>();

    const { loading: getLoading } = useRequest(() => getCompanysQueryLoginVerification(), {
        onSuccess: (res) => {
            form.setFieldsValue({
                twoStepVerification: res.data?.twoStepVerification === OpenMap.OPEN,
                // loginVerificationConfig: res.data?.loginVerificationConfig === OpenMap.OPEN,
                loginVerificationConfig: true,
            });
        },
    });

    const onEnableChange = (checked: boolean) => {
        if (checked) {
            Modal.warning({
                title: /* 注意 */ UdeskLocales['current'].pages.securitySettings.components
                    .verificationConfig.index.attention,
                content:
                    /* 开启二步验证后，未填写电话及电话填写有误的员工账号将无法登录系统，出现无法登录情况请联系管理员为员工账号修改正常的电话。 */UdeskLocales['current'].pages.securitySettings.components.verificationConfig.index.afterTheTwostepVerificationIsTurnedOnEmployeesWhosePhoneNumbersAreNotFilledInAndWhosePhoneNumbersAreIncorrectlyFilledInWillNotBeAbleToLogInToTheSystemInCaseOfFailureToLogInPleaseContactTheAdministratorToModifyTheNormalPhoneNumberForTheEmployeesAccount,
            });
        }
    };

    const [saveLoading, setSaveLoading] = useState(false);

    const onFinish = (values: FormValues) => {
        setSaveLoading(true);
        postCompanysLoginVerification({
            twoStepVerification: values.twoStepVerification ? OpenMap.OPEN : OpenMap.CLOSE,
            loginVerificationConfig: values.loginVerificationConfig ? OpenMap.OPEN : OpenMap.CLOSE,
        })
            .then(() => {
                message.success(
                    /* 保存成功 */ UdeskLocales['current'].pages.securitySettings.components
                        .verificationConfig.index.saveSuccessful
                );
            })
            .finally(() => {
                setSaveLoading(false);
            });
    };

    return (
        <Form<FormValues>
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{ loginVerificationConfig: true }}
        >
            <Spin spinning={getLoading}>
                <Form.Item
                    label={
                        /* 二步验证 */ UdeskLocales['current'].pages.securitySettings.components
                            .verificationConfig.index.twostepVerification
                    }
                    name="twoStepVerification"
                    valuePropName="checked"
                >
                    <Switch onChange={onEnableChange} />
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 2 }}>
                    <Form.Item name="loginVerificationConfig" valuePropName="checked" noStyle>
                        <Checkbox disabled>
                            {/* 登录 */}
                            {
                                UdeskLocales['current'].pages.securitySettings.components
                                    .verificationConfig.index.login
                            }
                        </Checkbox>
                    </Form.Item>
                </Form.Item>

                <Form.Item>
                    <Button
                        htmlType="submit"
                        type="primary"
                        disabled={saveLoading}
                        loading={saveLoading}
                    >
                        {/* 保存 */}
                        {
                            UdeskLocales['current'].pages.securitySettings.components
                                .verificationConfig.index.preserve
                        }
                    </Button>
                </Form.Item>
            </Spin>
        </Form>
    );
});

export default Template;
